import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { OpenTofuMigrationQueueEntryNode } from "shared/Stack/OpenTofuMigration/gql";

import { MIGRATION_QUEUE_COLUMN_ID } from "../constants";
import OpenTofuMigrationQueueTableLastUpdateCell from "./LastUpdateCell";
import OpenTofuMigrationQueueTableNoteCell from "./NoteCell";
import OpenTofuMigrationQueueTableStackCell from "./StackCell";
import OpenTofuMigrationQueueTableStateCell from "./StateCell";

export const MIGRATION_QUEUE_TABLE_CELLS: TableCellPerColumn<OpenTofuMigrationQueueEntryNode> = {
  [MIGRATION_QUEUE_COLUMN_ID.STATE]: OpenTofuMigrationQueueTableStateCell,
  [MIGRATION_QUEUE_COLUMN_ID.STACK]: OpenTofuMigrationQueueTableStackCell,
  [MIGRATION_QUEUE_COLUMN_ID.LAST_UPDATE]: OpenTofuMigrationQueueTableLastUpdateCell,
  [MIGRATION_QUEUE_COLUMN_ID.NOTE]: OpenTofuMigrationQueueTableNoteCell,
};
